import { render, staticRenderFns } from "./Plants.vue?vue&type=template&id=c2a42afc&scoped=true"
import script from "./Plants.vue?vue&type=script&lang=js"
export * from "./Plants.vue?vue&type=script&lang=js"
import style0 from "./Plants.vue?vue&type=style&index=0&id=c2a42afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a42afc",
  null
  
)

export default component.exports